import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { apiRequests } from '../../shared/api/apiRequests';
import { formatImageUrl } from '../../shared/utils/formatImageUrl';
import { Pagination } from '../../features/Pagination/Pagination';
import { PageBar } from '../../shared/ui/PageBar';
import { EntityCard } from '../../shared/ui/EntityCard';

const CountriesGroupsPage = () => {
  const [data, setData] = useState(null);
  const [searchValue, setSearchValue] = useState('');
  const [page, setPage] = useState(1);
  const [count, setCount] = useState(10);
  const location = useLocation();

  const getData = () => {
    apiRequests.countriesGroups.get(count, (page - 1) * count).then((res) => {
      setData(res);
    });
  };

  useEffect(() => {
    getData();
  }, [page, count]);

  const handleSearch = () => {
    // TODO: Implement search when API supports it
    getData();
  };

  const handleDelete = async (id) => {
    await apiRequests.countriesGroups.delete(id).then(() => {
      setData({
        ...data,
        items: data.items.filter((i) => i.id !== id),
      });
    });
  };

  if (!data) return <div>Загрузка...</div>;

  return (
    <>
      <PageBar
        searchValue={searchValue}
        onSearchChange={setSearchValue}
        onSearch={handleSearch}
        searchPlaceholder="Поиск групп стран..."
        createLink={`${location.pathname}/create`}
      />

      <div>
        <div className="mb-3">
          {data.items?.length === 0 ? (
            <p className="text-center">По вашему запросу ничего не найдено</p>
          ) : (
            data.items?.map((item) => (
              <EntityCard
                key={item.id}
                image={item.iconPath ? formatImageUrl(item.iconPath) : null}
                title={item.title}
                editLink={`${location.pathname}/${item.id}`}
                onDelete={() => handleDelete(item.id)}
              />
            ))
          )}
        </div>
        <Pagination
          count={data.totalCount}
          defaultPage={page}
          itemsPerPage={count}
          onChange={setPage}
        />
      </div>
    </>
  );
};

export default CountriesGroupsPage;
